import { Outlet } from 'react-router';

import { CheckStat } from '~/components/public/CheckStat';
import { ChatWidget } from '~/components/public/chat/ChatWidget';
import type { Route } from './+types/layout';

// app/routes/public/layout.tsx — een PADLOZE laag onder alle publieke routes.
//
// WAAROM DEZE LAAG BESTAAT. Elke publieke route wikkelt zichzelf in
// PublicLayout/PublicShell (home.tsx:28, artikel.tsx:77); er zat niets tussen
// root.tsx en die routes. Alles wat in PublicLayout hangt wordt daarom bij
// iedere navigatie opnieuw opgebouwd, en dan valt een lopend gesprek weg. In het
// bronproject speelde dat niet: dat was een SPA en de widget ging nooit weg.
//
// Deze laag lost de ZACHTE navigatie op. De harde navigatie (SiteHeader gebruikt
// nog rauwe <a href>) wordt opgevangen door het hervatten uit sessionStorage —
// zie app/lib/chat-visitor.ts. Die twee samen dekken alle gevallen.

export function loader({ context }: Route.LoaderArgs) {
  // Alleen deze booleaan. Een zwaardere loader hier zou een serverrondje vóór
  // élke publieke pagina zetten.
  return { chatEnabled: context.chatEnabled };
}

/**
 * NIET opnieuw ophalen bij navigatie.
 *
 * Zonder dit draait de loader hierboven bij élke client-navigatie opnieuw en
 * hangt er dus een extra `.data`-verzoek aan iedere paginawissel op de hele
 * publieke site — voor een waarde die binnen een sessie niet verandert. Dít is
 * de enige reden dat deze route überhaupt een loader mag hebben.
 */
export function shouldRevalidate() {
  return false;
}

export default function PublicRouteLayout({ loaderData }: Route.ComponentProps) {
  return (
    <>
      <Outlet />
      {/* De bezoekersteller hangt hier en niet in een losse route, om dezelfde
          reden als de chatwidget: deze laag blijft staan over routewissels
          heen, dus hij ziet élke navigatie. In een route zou hij bij iedere
          paginawissel opnieuw monteren en zijn vorige-pagina-geheugen kwijt
          zijn. Rendert niets. */}
      <CheckStat />
      {/* Staat de chat uit, dan staat de knop ook niet in de HTML. Geen knop die
          na de hydratatie wegspringt, en geen widget die stiekem toch praat. */}
      {loaderData.chatEnabled && (
        // .kb-public is een GESCOPEERD variabelenblok (theme.css:731), geen
        // erfenis van de route eronder: de widget staat als SIBLING van
        // <Outlet/> en zou dus op de compacte beheerschaal renderen — 13px op
        // een pagina van 14px, net verkeerd genoeg om niet op te vallen.
        <div className="kb-public">
          <ChatWidget />
        </div>
      )}
    </>
  );
}
